<i18n src="@/locales/models/delivery_process_provider.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/new_delivery_process_provider.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="this.routeName('show_process_delivery_process_providers')"
    :params="{
      service_provider_id: service_provider_id,
      delivery_process_id: delivery_process_id,
    }"
  />

  <bread-crumbs :labels="[module_name, delivery_process?.name]" />

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.delivery_process_provider.name") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="producers"
                  label="fullname"
                  v-model="delivery_process_provider.producer_id"
                  :is_invalid="isInvalidSelect('producer')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowProcess"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="create"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/manage_delivery_process_providers.js";
export default {
  name: "SPDeliveryDistributionNewDeliveryProcessProvider",
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      delivery_process: {},
      producers: [],
      delivery_process_provider: {
        producer_id: null,
      },
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      this.fetchDeliveryProcess();
      await this.fetchProducers();
      this.load_general_data = true;
    },

    fetchDeliveryProcess: async function () {
      const response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process = response.data;
    },

    fetchProducers: async function () {
      const response = await Requester.fetchProducers(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.producers = response.data;
    },

    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.create(
          this.service_provider_id,
          this.delivery_process_id,
          this.delivery_process_provider
        );

        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_save_button = false;
      }
    },

    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process_delivery_process_providers"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
        },
      });
    },
  },
};
</script>
